import { render, staticRenderFns } from "./AssetsCard.vue?vue&type=template&id=a6cb6090&"
import script from "./AssetsCard.vue?vue&type=script&lang=js&"
export * from "./AssetsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports